import AxiosInstance from "./apiClient";

//Create Account
export const createAccountApi = async ({
  token,
  fullName,
  gender,
  email,
  password,
}) => {
  const url = "auth/register";

  console.log(
    "Creating account with:",
    token,
    fullName,
    email,
    password,
    gender
  );

  try {
    const response = await AxiosInstance.post(url, {
      firebaseToken: token,
      name: fullName,
      email,
      password,
      gender,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

//Login
export const loginApi = async (token) => {
  const url = "auth/login";

  try {
    const response = await AxiosInstance.post(url, {
      firebaseToken: token,
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

//Logout
export const logoutApi = async () => {
  const url = "auth/logout";

  try {
    const response = await AxiosInstance.post(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

//Get User Profile Details
export const getUserProfileApi = async () => {
  const url = "auth/user";

  try {
    const response = await AxiosInstance.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    throw error;
  }
};

